import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

export const branchDetailsAdd = (branchData: any) => {
	const data = {
		AddBusinessTokenBranch: branchData,
	};
	const url = `${API_URL}addBusinessBranch`;
	return makeApiCall(url, data);
};

export const fetchBranchDetails = (fetchData: any) => {
	const data = {
		GetBusinessTokenBranch: fetchData,
	};
	const url = `${API_URL}getBusinessBranch`;
	return makeApiCall(url, data);
};

export const updateBranchDetails = (updateData: any) => {
	const data = {
		UpdateBranchDetailsToken: updateData,
	};
	const url = `${API_URL}updateBusinessBranch`;
	return makeApiCall(url, data);
};
